import { Header } from "@/components/site/Header";
import { Services } from "@/components/site/Services";
import { CTASection } from "@/components/site/CTASection";
import { Footer } from "@/components/site/Footer";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { PageHeroCard } from "@/components/site/PageHeroCard";
import { SamplingLocationsSection } from "@/components/site/SamplingLocationsSection";
import { useLang } from "@/i18n/LangContext";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import lakarintygHero from "@/assets/lakarintyg-hero.jpg";

import { PageMeta } from "@/components/site/PageMeta";

const Lakarintyg = () => {
  const { t, lang } = useLang();
  const bookingHref = lang === "sv" ? "/boka-tid" : "/en/book-appointment";



  const title = lang === "sv" ? "Läkarintyg – alla intyg | Intygsläkaren" : "Medical certificates – all types | Intygsläkaren";
  const desc = lang === "sv"
    ? "Över 30 typer av läkarintyg för körkort, sjöfolk, arbete, resor, försäkring och mer. Boka tid på Järntorget i Göteborg."
    : "Over 30 types of medical certificates for driving, seafaring, work, travel, insurance and more. Book at Järntorget, Gothenburg.";

  return (
    <div className="min-h-screen bg-background">
      <PageMeta title={title} description={desc} />
      <Header />
      <main>
        <PageHeroCard
          imageSrc={lakarintygHero}
          imageAlt={lang === "sv" ? "Läkare skriver läkarintyg" : "Doctor writing a medical certificate"}
        >
          <div className="relative z-20 max-w-2xl animate-fade-up lg:max-w-3xl">
            <span className="inline-flex h-8 items-center justify-center rounded-full border border-primary/10 bg-primary-soft px-3.5 text-xs font-medium leading-none text-primary shadow-[0_2px_6px_-2px_hsl(162_52%_8%/0.12)]">
              {t.services.eyebrow}
            </span>
            <h1 className="mt-5 text-balance font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-6xl">
              {t.services.title}
            </h1>
            <p className="mt-5 max-w-xl text-balance text-base leading-relaxed text-muted-foreground sm:text-lg">
              {t.services.subtitle}
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
              <Button asChild variant="hero" size="xl" className="w-full sm:w-auto">
                <a href={bookingHref}>
                  {t.hero.bookCta}
                  <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </Button>
              <Button asChild variant="ghost-outline" size="xl" className="w-full sm:w-auto">
                <a href="#certifikat">{t.hero.browseCta}</a>
              </Button>
            </div>
          </div>
        </PageHeroCard>
        <Services hideHeader />
        <SamplingLocationsSection className="bg-muted/20" />
        <CTASection />
        <Breadcrumbs
          items={[
            { label: lang === "sv" ? "Hem" : "Home", to: lang === "sv" ? "/" : "/en" },
            { label: t.nav.certificates },
          ]}
        />
      </main>
      <Footer />
    </div>
  );
};

export default Lakarintyg;
